import { formatNumber } from "~served/utils";
import currencyMap from "@dcspark/currency-symbol-map/map";
import { DEFAULT_CURRENCY_CODE } from "~served/configs";

export const $d = (amount: number, currencyCode?: string) => {
	const symbol = currencyMap[currencyCode ?? DEFAULT_CURRENCY_CODE];
	const absAmount = Math.abs(amount);

	return amount < 0
		? `- ${symbol} ${formatNumber(absAmount)}`
		: `${symbol} ${formatNumber(absAmount)}`;
};
